import { Alert, Autocomplete, Box, Button, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, Paper, Stack, styled, TextField, Typography } from "@mui/material";
import { GetClientsList } from "../../../hooks/getListClientes";
import { useMemo, useState } from "react";
import { GetPartsClientsList } from "../../../hooks/getPartesClienteList";
import moment from "moment";
import { GetPartesRevisiones } from "../../../hooks/partesRevisiones";
import { useSelector } from "react-redux";
import { ImageViewer } from "../../../components/FileDropper/imageViewer";
import { UploadFile } from "@mui/icons-material";
import { set } from "react-hook-form";
import { CreateHistorico } from "../../../hooks/historico";
import { EHISTACCION, EHISTSECCION } from "../../../@enums/historico";

const Item = styled(Paper)(({ theme }) => ({
  padding: 3,
  border: '1px solid #575E3B',
  borderRadius: 8,
  width: '100%',
}));



export const VisualizadorIndex = () => {

  const apiResources = useSelector((state) => state.app.apiResources);

  const { isLoading: isLoadingClients, isError: isErrorClients, data: clients, refetch: refetchClients } = GetClientsList();
  const [clienteSelect, setClientSelect] = useState(null);
  const { isLoading: isLoadingParts, isError: isErrorParts, data: parts = [], refetch: refetchParts } = GetPartsClientsList(clienteSelect?.value);
  const [partSelect, setPartSelect] = useState(null);
  const { isLoading: isLoadingRevs, isError: isErrorRevs, data: Revs = [], refetch: refetchRevs } = GetPartesRevisiones(partSelect?.value, true, true);
  const { createHistoricoMutation } = CreateHistorico();
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState([]);

  const filteredData = useMemo(() => {
    if (!Revs) return [];

    // if (filter.length === 0) return Revs; // Si no hay filtros, devuelve todos los elementos

    return Revs.filter(item =>
      filter.includes(item.pare_id) // <--- filtra por los IDs que tengas
    );
  }, [Revs, filter]);

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  const handleChangeClient = (newValue) => {
    setPartSelect(null);
    setFilter([])
    if (newValue === null) {
      setClientSelect(null);
    } else {
      setClientSelect(newValue);

    }
  }
  const handleChangePart = (newValue) => {
    setFilter([]);
    if (newValue === null) {
      setPartSelect(null);
    } else {
      setPartSelect(newValue);
    }
  }

  const saveHistorico = (url) => {
    createHistoricoMutation(
      {
        hist_accion: EHISTACCION.GET,
        hist_seccion: EHISTSECCION.VISUALIZADOR_RES,
        hist_datos: JSON.stringify({
          parte: partSelect?.label,
          recurso: url,
        })
      },
      {
        onSuccess: (data) => {

        },
        onError: (error) => {
          console.error("Error saving historico:", error);
        }
      }
    )
  }

  const handleImageClick = (imageUrl) => {
    let resUrl = `${apiResources}/${imageUrl}`
    setSelectedImage(resUrl);
    setOpenImage(true);
    saveHistorico(imageUrl);
  }

  const handleCloseImage = () => {
    setOpenImage(false);
    setSelectedImage(null);
  }

  const handleOpenPDF = (pdfUrl) => {
    // let resUrl = `${apiResources}/${pdfUrl}`
    let resUrl = `https://docs.google.com/gview?url=${encodeURIComponent(`${apiResources}/${pdfUrl}`)}`;
    window.open(resUrl, '_blank');
    saveHistorico(pdfUrl);
  };

  const handleChangeFilter = (event, value) => {
    const { checked } = event.target;
    if (checked) {
      setFilter((prev) => [...prev, value]);
    } else {
      setFilter((prev) => prev.filter((id) => id !== value));
    }
  }



  return (
    <Grid container spacing={0}>

      <Grid item xs={6} sm={6} md={3} sx={{ p: 2 }} className="center_item">
        <Autocomplete
          fullWidth
          id="emp_id"
          getOptionLabel={(opcion) => opcion.label}
          filterSelectedOptions
          options={clients}
          onKeyDown={handleKeyUp}
          value={clienteSelect}
          onChange={(e, newValue) => handleChangeClient(newValue)}
          renderOption={(props, option) => (
            <Box {...props} key={option?.value}>{option.label}</Box>
          )}
          renderInput={(params) =>
            <TextField {...params} label="Cliente" size="small" fullWidth required />
          }
        />
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ p: 2 }} className="center_item">
        <Autocomplete
          fullWidth
          id="part_id"
          getOptionLabel={(opcion) =>
            opcion?.codigo !== undefined ?
              `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida} / ${opcion?.codigo_alterno}` :
              opcion?.label
          }
          filterSelectedOptions
          options={parts}
          onKeyDown={handleKeyUp}
          value={partSelect}
          disabled={!parts || !clienteSelect}
          onChange={(e, newValue) => handleChangePart(newValue)}
          renderOption={(props, option) => (
            <Box {...props} key={option?.value}>
              {option?.codigo !== undefined ? option?.codigo : <></>} /
              {option?.codigo_salida !== undefined ? option?.codigo_salida : <></>} /
              {option?.codigo_alterno !== undefined ? option?.codigo_alterno : <></>} / {option?.label}
            </Box>
          )}
          renderInput={(params) =>
            <TextField {...params} label="Cliente" size="small" fullWidth required />
          }
        />
      </Grid>
      {
        Revs.length > 0 && (
          <Grid item xs={12} sx={{ p: 2 }} className="center_item">
            <>
              <Grid container spacing={0} sx={{ width: '100%' }}>
                <Grid item xs={12} sm={12} md={3} sx={{ p: 2 }}>
                  <Item>
                    <FormGroup sx={{ p: 2 }}>
                      {
                        Revs?.map((rev) => (
                          <FormControlLabel control={
                            <Checkbox onChange={(e) => handleChangeFilter(e, rev?.pare_id)}/>
                          }
                            label={rev?.pare_nombre}
                          />
                        ))}
                    </FormGroup>
                  </Item>
                </Grid>
                <Grid item xs={12} sm={12} md={9} sx={{ p: 2 }} >
                  {
                    filteredData.length > 0 && filteredData?.map((rev) => (
                      <Box sx={{ width: '100%' }}>
                        <Stack spacing={1} key={rev?.pare_id} sx={{ mb: 1, pr: 1 }}>
                          <Item>
                            <Grid container spacing={1} sx={{ p: 2 }}>
                              <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', borderRight: '1px solid #575E3B' }} >
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#575E3B', mb: 1 }}>
                                  {rev?.pare_nombre?.toUpperCase()}
                                </Typography>
                                <span>N° de dibujo</span>
                                <Typography sx={{ fontWeight: 'bold', color: '#575E3B', mb: 1 }}>
                                  {rev?.pare_numerodibujo}
                                </Typography>
                                <span>Fecha de dibujo</span>
                                <Typography sx={{ fontWeight: 'bold', color: '#575E3B', mb: 1 }}>
                                  {rev?.pare_fechadibujo ? moment(rev?.pare_fechadibujo).format('DD/MM/yyyy') : ''}
                                </Typography>
                                <span>Cambio de ingeniería</span>
                                <Typography sx={{ fontWeight: 'bold', color: '#575E3B', mb: 1 }}>
                                  {rev?.pare_cambioingenieria}
                                </Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <Grid container spacing={1} sx={{ p: 2 }}>
                                  {
                                    rev?.recursos?.map((res) => (
                                      <Grid item xs={12} sm={6} md={4} key={`res_rev_${res?.recu_id}`} sx={{ p: 2 }}>
                                        <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                                          {res.recu_mime.startsWith('image') ? (
                                            <Box
                                              component="img"
                                              src={`${apiResources}/${res?.recu_ruta}`}
                                              alt={res?.recu_nombre}
                                              sx={{
                                                width: 60,
                                                height: 60,
                                                objectFit: 'cover',
                                                mr: 2,
                                                borderRadius: 1,
                                              }}
                                              onClick={() => handleImageClick(res?.recu_ruta)}
                                            />
                                          ) : (
                                            <Box
                                              sx={{
                                                minWidth: 60,
                                                height: 60,
                                                mr: 2,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                bgcolor: 'grey.200',
                                                borderRadius: 1,
                                              }}
                                              onClick={() => handleOpenPDF(res?.recu_ruta)}
                                            >
                                              <UploadFile />
                                            </Box>
                                          )}
                                          <Typography noWrap sx={{ flexGrow: 1 }}>{res?.recu_nombre}</Typography>
                                        </Paper>
                                      </Grid>
                                    ))
                                  }
                                </Grid>

                              </Grid>
                            </Grid>
                          </Item>
                        </Stack>
                      </Box>
                    ))
                  }
                  {
                    filteredData.length === 0 && 
                    <Alert severity="warning" sx={{ width: '100%' }}>Seleccione las revisiones que desee consultar</Alert>
                  }
                </Grid>
              </Grid>
            </>
          </Grid>
        )
      }
      {
        Revs.length === 0 && isLoadingRevs && <Grid item xs={12} className="center_item"><CircularProgress /></Grid>
      }
      {
        Revs.length === 0 && isErrorRevs &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
          <Alert severity="error" sx={{ width: '100%' }}>No se pudieron cargar los archivos</Alert>
        </Grid>
      }
      {
        Revs.length === 0 && !isErrorRevs && !isLoadingRevs &&
        <Grid item xs={12} sx={{ p: 2, mt: 3, display: 'flex', alignItems: 'center' }} >
          <Alert severity="warning" sx={{ width: '100%' }}>No hay archivos para mostrar</Alert>
        </Grid>
      }

      {
        isLoadingClients && <Grid item xs={12} className="center_item"><CircularProgress /></Grid>
      }
      {isErrorClients &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
          <Alert severity="error" sx={{ width: '100%' }}>No se pudieron cargar los archivos</Alert>
        </Grid>
      }
      {
        openImage && selectedImage &&
        <ImageViewer
          key={`image_viewer`}
          open={openImage}
          handleClose={handleCloseImage}
          selectedImage={selectedImage}
        />
      }
    </Grid>
  )
}